import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { EASE_OUT, VIEWPORT_DEFAULT } from '@/lib/motion';

const wordVariants = {
  hidden: { y: '110%' },
  show: { y: '0%', transition: { duration: 0.6, ease: EASE_OUT } },
};

/**
 * Splits `text` into words and reveals them rising up from a mask, word by
 * word, as it scrolls into view. Built for hero/section headlines -- pass
 * the heading's own text, keep markup (bold spans etc.) out of it.
 */
const TextReveal = ({
  text,
  as = 'h1',
  className,
  wordClassName,
  delay = 0,
  stagger = 0.04,
  viewport = VIEWPORT_DEFAULT,
}) => {
  const MotionTag = motion[as] || motion.h1;
  const words = text.split(' ');

  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      transition={{ staggerChildren: stagger, delayChildren: delay }}
    >
      {words.map((word, i) => (
        <span key={i} className="inline-block overflow-hidden align-top" style={{ marginRight: '0.28em' }}>
          <motion.span className={cn('inline-block', wordClassName)} variants={wordVariants}>
            {word}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};

export default TextReveal;
